import { toCentesimal } from '../../../utils/transform';
import { InvoiceFormType } from '../../forms/invoice/types';
import { useInvoiceDataConfirmation } from './useInvoiceDataConfirmation';

type Props = {
  onSuccess?: (id: string) => void;
  onError?: (status: number) => void;
  onValidationError?: () => void;
};
export const useConfirmInvoiceForm = ({ onSuccess, onError, onValidationError }: Props) => {
  const {
    confirmInvoice,
    state: { isLoading, isReady },
  } = useInvoiceDataConfirmation({
    onSuccess: (id) => onSuccess?.(id),
    onError: (status) => onError?.(status),
  });

  const onFormSubmit = (invoiceId: string, data: InvoiceFormType) => {
    try {
      confirmInvoice(invoiceId, {
        ...data,
        amount: toCentesimal(data.amount ?? 0),
        amountDue: toCentesimal(data.amountDue ?? 0),
        items: data.items?.map((item) => ({
          ...item,
          priceWithoutVat: item.priceWithoutVat ? toCentesimal(item.priceWithoutVat) : undefined,
        })),
      });
    } catch (e) {
      console.error(e);
      onValidationError?.();
    }
  };

  return {
    onFormSubmit,
    state: {
      isLoading,
      isReady,
    },
  };
};
